//Datepicker periods
export const ALL_TIME = 'all_time';
export const PREVIOUS_WEEK = 'previous_week';
export const LAST_7_DAYS = 'last_7_days';
export const PREVIOUS_MONTH = 'previous_month';
export const LAST_30_DAYS = 'last_30_days';
export const LAST_3_MONTHS = 'last_3_months';
export const THIS_YEAR = 'this_year';
export const PREVIOUS_YEAR = 'previous_year';
export const CURRENT_QUARTER = 'this_quarter';
export const PREVIOUS_QUARTER = 'previous_quarter';
export const CUSTOM = 'custom';
export const LAST_DAY = 'last_day';
export const CURRENT_WEEK = 'this_week';
export const CURRENT_MONTH = 'this_month';

//comparison periods
export const PREVIOUS_PERIOD = 'previous_period';
export const SAME_PERIOD_LAST_YEAR = 'same_period_last_year';

export const periodsTranslation: Record<DatepickerPeriodsAvailableType, string> = {
    all_time: 'commons:datepicker.all_time',
    previous_week: 'commons:datepicker.previous_week',
    last_7_days: 'commons:datepicker.last_7_days',
    previous_month: 'commons:datepicker.previous_month',
    last_30_days: 'commons:datepicker.last_30_days',
    last_3_months: 'commons:datepicker.last_3_months',
    this_year: 'commons:datepicker.this_year',
    previous_year: 'commons:datepicker.previous_year',
    this_quarter: 'commons:datepicker.this_quarter',
    previous_quarter: 'commons:datepicker.previous_quarter',
    custom: 'commons:datepicker.custom',
    last_day: 'commons:datepicker.last_day',
    this_week: 'commons:datepicker.this_week',
    this_month: 'commons:datepicker.this_month'
};

export type DatepickerGlobalPeriodsType =
    | typeof PREVIOUS_WEEK
    | typeof LAST_7_DAYS
    | typeof PREVIOUS_MONTH
    | typeof LAST_30_DAYS
    | typeof THIS_YEAR
    | typeof PREVIOUS_YEAR
    | typeof CUSTOM;

export const datepickerGlobalPeriods: DatepickerGlobalPeriodsType[] = [
    LAST_7_DAYS,
    LAST_30_DAYS,
    THIS_YEAR,
    PREVIOUS_WEEK,
    PREVIOUS_MONTH,
    PREVIOUS_YEAR,
    CUSTOM
];

export type DatepickerPeriodsAvailableType =
    | typeof ALL_TIME
    | typeof PREVIOUS_WEEK
    | typeof LAST_7_DAYS
    | typeof PREVIOUS_MONTH
    | typeof LAST_30_DAYS
    | typeof LAST_3_MONTHS
    | typeof THIS_YEAR
    | typeof PREVIOUS_YEAR
    | typeof CURRENT_QUARTER
    | typeof PREVIOUS_QUARTER
    | typeof CUSTOM
    | typeof LAST_DAY
    | typeof CURRENT_WEEK
    | typeof CURRENT_MONTH;

export type DatepickerComparisonPeriodsAvailableType =
    | typeof PREVIOUS_PERIOD
    | typeof SAME_PERIOD_LAST_YEAR;

export const dataCompareTo = [
    { label: 'commons:datepicker.previous_period', value: PREVIOUS_PERIOD },
    { label: 'commons:datepicker.same_period_last_year', value: SAME_PERIOD_LAST_YEAR }
] as const;
